import { isOralExamTaken } from '@/common/utils/oralExam/examTaken';
import { isOralExamPracticeTask } from '@/common/utils/oralExam/practiceApi';
import { useEventTaskSlots } from '@/student/module/hooks/useEventTaskSlots';
import type { Task } from '../types';

/**
 * Whether the student has taken this graded oral exam (task marked done or the
 * registered sitting completed). Always false for other task types and dry runs.
 */
export const useOralExamTaken = (
  task: Task,
  courseId: string,
  moduleId: string,
  moduleVersion: string | undefined,
): boolean => {
  const isGradedOralExam = task.type === 'oral_exam' && !isOralExamPracticeTask(task);
  const { currentBooking } = useEventTaskSlots(courseId, moduleId, moduleVersion, task.id, {
    enabled: isGradedOralExam,
    pollSlots: false,
    pollBookings: false,
    task,
  });
  return isGradedOralExam && isOralExamTaken(task, currentBooking);
};
